import { useState, useEffect } from 'react';

export default function ConfirmDeleteModal({ open, onClose, onConfirm, itemType, itemName, warningText }) {
  const [typed, setTyped] = useState('');

  useEffect(() => {
    if (open) setTyped('');
  }, [open]);

  if (!open) return null;

  const match = typed === itemName;

  return (
    <>
      <div
        onClick={onClose}
        style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', zIndex: 3000 }}
      />
      <div style={{
        position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%,-50%)',
        width: 'calc(100vw - 2rem)', maxWidth: 440, maxHeight: '85dvh',
        overflowY: 'auto', background: '#fff', borderRadius: 12,
        boxShadow: '0 8px 32px rgba(0,0,0,0.22)', zIndex: 3001,
        padding: '1.5rem', boxSizing: 'border-box',
      }}>
        <h3 style={{ margin: '0 0 0.6rem', fontFamily: "'Poppins', sans-serif", color: '#c0392b', fontSize: '1.1rem' }}>
          Delete {itemType}?
        </h3>
        <p style={{ margin: '0 0 1rem', fontSize: '0.875rem', color: '#555', lineHeight: 1.55 }}>
          {warningText} <strong>This cannot be undone.</strong>
        </p>
        <p style={{ margin: '0 0 0.4rem', fontSize: '0.82rem', color: '#333', fontWeight: 600 }}>
          Type <span style={{ fontFamily: 'monospace', color: '#c0392b', fontWeight: 700 }}>{itemName}</span> to confirm:
        </p>
        <input
          autoFocus
          value={typed}
          onChange={e => setTyped(e.target.value)}
          placeholder={itemName}
          onKeyDown={e => { if (e.key === 'Enter' && match) { onConfirm(); onClose(); } }}
          style={{
            width: '100%', boxSizing: 'border-box',
            padding: '0.5rem 0.75rem', borderRadius: 7,
            border: `1.5px solid ${match ? '#c0392b' : '#ddd'}`,
            fontSize: '0.875rem', fontFamily: 'inherit', outline: 'none',
            marginBottom: '1.25rem',
          }}
        />
        <div style={{ display: 'flex', gap: '0.6rem', justifyContent: 'flex-end' }}>
          <button
            onClick={onClose}
            style={{
              padding: '0.55rem 1.25rem', borderRadius: 7, border: '1.5px solid #ddd',
              background: '#fff', color: '#333', fontWeight: 700, fontSize: '0.9rem',
              cursor: 'pointer', fontFamily: 'inherit',
            }}
          >
            Cancel
          </button>
          <button
            onClick={() => { if (!match) return; onConfirm(); onClose(); }}
            disabled={!match}
            style={{
              padding: '0.55rem 1.25rem', borderRadius: 7, border: 'none',
              background: match ? '#c0392b' : '#e8a0a0', color: '#fff',
              fontWeight: 700, fontSize: '0.9rem',
              cursor: match ? 'pointer' : 'not-allowed', fontFamily: 'inherit',
            }}
          >
            Delete
          </button>
        </div>
      </div>
    </>
  );
}
